import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_V_L } from '@nu-art/thunderstorm-frontend';
import './Component_AdvisorSL_Recap.scss';
import { Component_AdvisorSL_FeedItem } from './Component_AdvisorSL_FeedItem.js';
export const Component_AdvisorSL_Recap = () => {
    return _jsxs(LL_V_L, { className: 'c-asl-recap', children: [_jsx(Component_AdvisorSL_FeedItem, {}), _jsx(Component_AdvisorSL_FeedItem, {}), _jsx(Component_AdvisorSL_FeedItem, {}), _jsx(Component_AdvisorSL_FeedItem, {})] });
};
//# sourceMappingURL=Component_AdvisorSL_Recap.js.map